export const depositStatus =  {
    0: {
      name: "",
      color: "",
    },
    1: {
      name: "Chờ xét duyệt",
      color: "warning",
    },
    2: {
      name: "Đã duyệt",
      color: "success",
    },
    3: {
      name: "Bị hủy",
      color: "danger",
    },
    4: {
      name: "Đã bán",
      color: "primary",
    },
    5: {
      name: "Sắp hết hạn",
      color: "secondary",
    },
    6: {
      name: "Quá hạn xét duyệt",
      color: "danger",
    },
    7: {
      name: "Hết hạn",
      color: "danger",
    },
  };